import React, { useEffect, useState } from 'react';
import './App.css';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useUser } from './auth/UseUser';
import axios from 'axios';
import Loading from './components/Loading';
import { Toaster } from 'react-hot-toast';
import PublicRoute from './router/PublicRoute';
import PrivateRoute from './router/PrivateRoute';
import LoginScreen from './components/login/LoginScreen';
import Layout from './components/login/Layout';
import CoursesHome from './components/courses/CoursesHome';
import SolutionsHome from './components/solutions/SolutionsHome';
import SingleCourseScreen from './components/courses/SingleCourseScreen';
import { whoAmI } from './server/server';
import PracticeHome from './components/practices/PracticesHome';
import SinglePracticeScreen from './components/practices/SinglePracticeScreen';
import CategoriesHome from './components/categories/CategoriesHome';
import SingleCategoryScreen from './components/categories/SingleCategoryScreen';
import SingleSolutionScreen from './components/solutions/SingleSolutionScreen';
import SolutionCategoriesHome from './components/solution-categories/SolutionCategoriesHome';
import SingleSolutionCategoryScreen from './components/solution-categories/SingleSolutionCategoryScreen';
import QuickTipsHome from './components/quick-tips/QuickTipsHome';
import UserManagement from './components/user-management/UserManagement';
import OnboardingAnalyticsHome from './components/onboarding-analytics/OnboardingAnalyticsHome';
import StruggleRecommendationsHome from './components/recommendations/StruggleRecommendationsHome';
import SingleStruggleRecommendationScreen from './components/recommendations/SingleStruggleRecommendationScreen';
import UserProfileScreen from './components/user-management/UserProfileScreen';
import AiPromptsHome from './components/ai-prompts/AiPromptsHome';
import PrivilegedAccessHome from './components/privileged-access/PrivilegedAccessHome';

function App() {
	const { user, setUser } = useUser();
	const [authLoading, setAuthLoading] = useState(true);
	const navigate = useNavigate();

	useEffect(() => {
		checkUserAuth();
	}, []);

	const logoutUser = () => {
		localStorage.clear();
		setUser({});
		navigate('/login');
	};

	axios.interceptors.response.use(
		function (response) {
			// Any status code that lie within the range of 2xx cause this function to trigger
			// Do something with response data
			return response;
		},
		function (error) {
			// Any status codes that falls outside the range of 2xx cause this function to trigger
			// Do something with response error
			let originalRequestConfig = error.response.config;
			if (error.response.status === 401 && !originalRequestConfig._retry) {
				originalRequestConfig._retry = true;
				console.log('response status is 401 ', originalRequestConfig);
				// notif('Istekao je vas token, molim vas ponovo se prijavite');
				logoutUser();
			}
			return Promise.reject(error);
		}
	);

	const checkUserAuth = async () => {
		const resp = await whoAmI();
		if (resp?.status === 200) {
			const user = resp.data;
			setUser(user);
			const location = window.location.pathname;
			if (location === '/' || location === '') {
				navigate('/courses');
			}
			setAuthLoading(false);
		} else if (resp?.status === 406) {
			logoutUser();
			setAuthLoading(false);
		} else {
			logoutUser();
			setAuthLoading(false);
		}
	};
	return (
		<>
			{!authLoading ? (
				<div id='home'>
					<Routes>
						<Route path='/login' element={<PublicRoute Component={LoginScreen} />} />
						<Route path='/' element={<Layout />}>
							<Route path='courses' element={<PrivateRoute Component={CoursesHome} />} />
							<Route path='courses/:id' element={<PrivateRoute Component={SingleCourseScreen} />} />
							<Route path='practices' element={<PrivateRoute Component={PracticeHome} />} />
							<Route path='practices/:id' element={<PrivateRoute Component={SinglePracticeScreen} />} />
							<Route path='course-categories' element={<PrivateRoute Component={CategoriesHome} />} />
							<Route path='course-categories/:id' element={<PrivateRoute Component={SingleCategoryScreen} />} />
							<Route path='solutions' element={<PrivateRoute Component={SolutionsHome} />} />
							<Route path='solutions/:id' element={<PrivateRoute Component={SingleSolutionScreen} />} />
							<Route path='solution-categories' element={<PrivateRoute Component={SolutionCategoriesHome} />} />
							<Route path='solution-categories/:id' element={<PrivateRoute Component={SingleSolutionCategoryScreen} />} />
							<Route path='quick-tips' element={<PrivateRoute Component={QuickTipsHome} />} />

							<Route path='parent-solutions' element={<PrivateRoute Component={SolutionsHome} />} />
							<Route path='parent-solutions/:id' element={<PrivateRoute Component={SingleSolutionScreen} />} />

							<Route path='parent-solution-categories' element={<PrivateRoute Component={SolutionCategoriesHome} />} />
							<Route path='parent-solution-categories/:id' element={<PrivateRoute Component={SingleSolutionCategoryScreen} />} />
							<Route path='parent-quick-tips' element={<PrivateRoute Component={QuickTipsHome} />} />

							<Route path='user-management' element={<PrivateRoute Component={UserManagement} />} />
							<Route path='user/:id' element={<PrivateRoute Component={UserProfileScreen} />} />
							<Route path='onboarding-analytics' element={<PrivateRoute Component={OnboardingAnalyticsHome} />} />

							<Route path='struggle-recommendations' element={<PrivateRoute Component={StruggleRecommendationsHome} />} />
							<Route path='struggle-recommendations/:id' element={<PrivateRoute Component={SingleStruggleRecommendationScreen} />} />

							<Route path='ai-prompts' element={<PrivateRoute Component={AiPromptsHome} />} />
							<Route path='privileged-access' element={<PrivateRoute Component={PrivilegedAccessHome} />} />
						</Route>
						<Route path='*' element={<PublicRoute Component={LoginScreen} />} />
					</Routes>
					<Toaster
						position='top-right'
						reverseOrder={false}
						containerStyle={{
							top: 40,
						}}
					/>
				</div>
			) : (
				<div className='flex items-center justify-center h-[100vh] w-[100vw] bg-greyBackground'>
					<Loading size={70} />
				</div>
			)}
		</>
	);
}

export default App;
